import { useDispatch } from "react-redux";
import { toggleTheme } from "../../features/themeSlice";
import RoundedSwitch from "./RoundedSwitch";

export default function ThemeSwitcher() {
  const dispatch = useDispatch();

  return <RoundedSwitch onChange={() => dispatch(toggleTheme())} />;
}
